import { DinMisstanke, RootState, VilkenRoll } from "@/store/types";

type v = 0 | 1;
export type MatrixServiceRow = [v, v, v, v];

/* eslint-disable-next-line complexity */
export function matrixServiceSelectorAdapter(
    row: MatrixServiceRow,
    { forsteg }: RootState,
): boolean {
    if (
        forsteg.vilkenroll === VilkenRoll.PRIVATPERSON &&
        forsteg.misstanke === DinMisstanke.PRIVATPERSON &&
        row[0]
    ) {
        return true;
    }
    if (
        forsteg.vilkenroll === VilkenRoll.PRIVATPERSON &&
        forsteg.misstanke === DinMisstanke.FORETAG &&
        row[1]
    ) {
        return true;
    }
    if (
        forsteg.vilkenroll === VilkenRoll.MYNDIGHET &&
        forsteg.misstanke === DinMisstanke.PRIVATPERSON &&
        row[2]
    ) {
        return true;
    }
    if (
        forsteg.vilkenroll === VilkenRoll.MYNDIGHET &&
        forsteg.misstanke === DinMisstanke.FORETAG &&
        row[3]
    ) {
        return true;
    }
    return false;
}
